<template>
  <div>
    <div class="row">
      <div v-for="(customer, index) in customers_with_users" :key="index" class="col-lg-6">
        <div class="kt-portlet kt-portlet--bordered kt-portlet--height-fluid">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="la la-user" />
              </span>
              <h3 class="kt-portlet__head-title">
                {{ customer.name }} <span v-if="!customer.status" class="text-danger ml-2">(DISABLED)</span>
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <storage-limit-progress-bar :customer="customer" />
            <div class="w-100 mt-2 mb-2">
              <hr>
            </div>
            <div class="row mb-4">
              <div class="col-lg-12">
                <h5>Customer Info</h5>
                <div class="d-flex flex-row flex-wrap">
                  <div class="p-2 w-50">
                    <b>Slug:</b> {{ customer.slug }}
                  </div>
                  <div class="p-2 w-50">
                    <b>UUID:</b> {{ customer.uuid }}
                  </div>
                  <div class="p-2 w-50">
                    <b>Plan:</b> {{ customer.plan.label }}
                  </div>
                  <div class="p-2 w-50">
                    <b>Ads Enabled:</b> {{ customer.ads_enabled ? "Yes" : "No" }}
                  </div>
                  <a href="/feeds" class="p-2 w-50 list-group-item-action">
                    <b>Feeds:</b> {{ customer.feeds_count }}
                  </a>
                  <a href="/live-feeds" class="p-2 w-50 list-group-item-action">
                    <b>Live Feeds:</b> {{ customer.live_feeds_count }}
                  </a>
                  <a href="/items" class="p-2 w-50 list-group-item-action">
                    <b>{{ item_is_episode ? "Episodes" : 'Items' }}:</b> {{ customer.items_count }}
                  </a>
                  <div class="p-2 w-50">
                    <b>API Access:</b> {{ customer.api_access ? "Yes" : "No" }}
                  </div>
                </div>
              </div>
            </div>

            <h5>Users</h5>
            <div class="row">
              <div class="col-12">
                <user-table :auth-user="activeUser" :users="getUsers(customer)" :show-headers="false" />
              </div>
            </div>

            <div v-if="getUploaderUsers(customer).length">
              <h5>Uploaders</h5>
              <div class="row">
                <div class="col-12">
                  <user-table :auth-user="activeUser" :users="getUploaderUsers(customer)" :show-headers="false" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="kt-portlet kt-portlet--bordered">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="la la-building" />
              </span>
              <h3 class="kt-portlet__head-title">
                Manage Organisation Access
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <user-customer-table v-if="customers_with_users && organisation_users" :customers-with-users="customers_with_users" :organisation-users="organisation_users" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserCustomerTable from "VuePartials/App/Organisations/UserCustomerTable";
import StorageLimitProgressBar from "VuePartials/StorageLimitProgressBar";
import UserTable from "VuePartials/App/UserTable";

export default {
  components: {
    UserCustomerTable,
    StorageLimitProgressBar,
    UserTable,
  },
  data: () => ({
    customers_with_users: window.customers_with_users,
    organisation_users: window.organisation_users,
    activeUser: window.user,
    feeds: window.feeds,
    items: window.items,
    item_is_episode: window.preferences.item_is_episode,
  }),
  methods: {
    getUsers(customer) {
      return _.filter(customer.users, user => !user.is_uploader);
    },
    getUploaderUsers(customer) {
      return _.filter(customer.users, user => user.is_uploader);
    },
  },
};
</script>

<style type="scss" scoped>
.kt-widget24 {
  padding:0;
}
</style>
